// modules
import { createAction } from 'redux-actions'

// actions
export const setPatientGamificationWallet = createAction(
  'SET_PATIENT_GAMIFICATION_WALLET'
)
export const setPatientGamificationWalletHistory = createAction(
  'SET_PATIENT_GAMIFICATION_WALLET_HISTORY'
)

export const setPatientGamificationRewardTasks = createAction(
  'SET_PATIENT_GAMIFICATION_REWARD_TASKS'
)
export const setPatientGamificationRewardAchievements = createAction(
  'SET_PATIENT_GAMIFICATION_REWARD_ACHIEVEMENTS'
)

export const setPatientGamificationLoader = createAction(
  'SET_PATIENT_GAMIFICATION_LOADER'
)
export const setPatientGamificationCompliance = createAction(
  'SET_PATIENT_GAMIFICATION_COMPLIANCE'
)

export const setPatientGamificationMedal = createAction(
  'SET_PATIENT_GAMIFICATION_MEDAL'
)
export const setPatientGamificationActivitiesLoading = createAction(
  'SET_PATIENT_GAMIFICATION_ACTIVITIES_LOADING'
)
export const setPatientGamificationActivities = createAction(
  'SET_PATIENT_GAMIFICATION_ACTIVITIES'
)

export const setGamificationModules = createAction('SET_GAMIFICATION_MODULES')
export const setGamificationAchievements = createAction(
  'SET_GAMIFICATION_ACHIEVEMENTS'
)

export const setPatientMedicationCompliance = createAction(
  'SET_PATIENT_MEDICATION_COMPLIANCE'
)
